<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/multiple-shipping-checkout/shared/multiple-shipping-checkout-button/multiple-shipping-checkout-button.component.ts
-->
<ng-template #anchor></ng-template>
